import MiniChatCategory from './MiniChatCategory.vue';
import MiniChatList from './MiniChatList.vue';
import MiniChat from './MiniChat.vue';
export default {
  MiniChatCategory,
  MiniChatList,
  MiniChat,
};
